module.exports = __webpack_public_path__ + "static/img/bicon28.4b884ff.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/bicon28.png
// module id = 1442
// module chunks = 3